import axios from "axios";

export const configService = {
  getConfig
};

async function getConfig() {
  return await axios({
    url: process.env.VUE_APP_API_URL + "config",
    method: "GET"
  });
}
